import { gql } from '@apollo/client'
import { graphql } from '@/graphql-setup'

export const INFRINGEMENT_MARKERS_QUERY = graphql(`
  query InfringementMarkers(
    $userId: ID!
    $dateStart: DateTime!
    $dateEnd: DateTime!
  ) {
    infringementMarkers(
      userId: $userId
      dateStart: $dateStart
      dateEnd: $dateEnd
    ) {
      id
      infringementTimestamp
      severity
      categoryIdentifier
    }
  }
`)

export const INFRINGEMENT_QUERY = graphql(`
  query Infringement(
    $id: ID!
    $activitiesExtendBeforeMinutes: Int
    $activitiesExtendAfterMinutes: Int
  ) {
    infringement(id: $id) {
      id
      createdAt
      reasonValue

      periodStartDate
      periodEndDate

      infringementTimestamp
      valueKind
      valueMagnitudeMinutes
      recordedTotalMinutes
      limitMinutes

      relatedIssues {
        id
        closedAt
      }

      issueReason

      archivedBy {
        id
        fullName
      }
      archivedAt
      archivedBasis
      closedAt
      solution
      leadersComment
      attachments {
        edges {
          node {
            id
            name
            file
          }
        }
      }
      actionLogs {
        edges {
          node {
            id
            action
            createdAt
            user {
              id
              fullName
            }
            secondaryUser {
              id
              fullName
            }
          }
        }
      }
      user {
        id
        fullName
      }
      infringementCategory {
        id
        identifier
        lowerLimit
        upperLimit
        value
        severity
        description
        legalBases {
          edges {
            node {
              article
            }
          }
        }
      }
      activities(
        extendBeforeMinutes: $activitiesExtendBeforeMinutes
        extendAfterMinutes: $activitiesExtendAfterMinutes
      ) {
        id
        activityType
        datetimeStart
        datetimeEnd
        vehicleRegistrationNumber
      }
    }
  }
`)

export const ALL_INFRINGEMENTS_QUERY = graphql(`
  query AllInfringements(
    $first: Int
    $after: String
    $users: [ID]
    $q: String
    $orderBy: String
    $includeStatuses: [InfringementStatus]
    $excludeSeverities: [String]
    $excludeCategories: [String]
    $infringementTimestamp_Lt: DateTime
    $infringementTimestamp_Gte: DateTime
    $leaderGroupId: ID
  ) {
    allInfringements(
      first: $first
      after: $after
      users: $users
      q: $q
      orderBy: $orderBy
      includeStatuses: $includeStatuses
      excludeSeverities: $excludeSeverities
      excludeCategories: $excludeCategories
      infringementTimestamp_Lt: $infringementTimestamp_Lt
      infringementTimestamp_Gte: $infringementTimestamp_Gte
      leaderGroupId: $leaderGroupId
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          infringementCategory {
            id
            identifier
            severity
            description
          }
          infringementTimestamp
          archivedAt
          closedAt
          status
          user {
            id
            fullName
            phoneNumber
          }
          hasClosedIssue
          latestActionLog {
            id
            action
            user {
              id
              fullName
            }
            secondaryUser {
              id
              fullName
            }
            createdAt
          }
        }
      }
    }
  }
`)

export const USER_INFRINGEMENTS = gql`
  query UserInfringements(
    $user: ID!
    $dateGte: DateTime
    $dateLt: DateTime
    $orderBy: String
  ) {
    user(id: $user) {
      id
      fullName
      phoneNumber
      email
      notificationEmail
      infringementsTotalValue
      infringementCount
      minorInfringementCount
      seriousInfringementCount
      verySeriousInfringementCount
      mostSeriousInfringementCount
      userTypes {
        name
      }
    }
    allInfringements(
      user: $user
      infringementTimestamp_Gte: $dateGte
      infringementTimestamp_Lt: $dateLt
      orderBy: $orderBy
      archivedAt_Isnull: true
    ) {
      edges {
        node {
          id
          archivedAt
          infringementTimestamp
          infringementCategory {
            id
            identifier
            value
            severity
          }
        }
      }
    }
  }
`

export const ALL_USER_INFRINGEMENTS_QUERY = gql`
  query AllUsersInfringementsSums(
    $first: Int
    $after: String
    $q: String
    $orderBy: String
    $users: [ID]
    $dateGte: DateTime!
    $dateLt: DateTime!
  ) {
    allUsersInfringementsSums(
      first: $first
      after: $after
      q: $q
      orderBy: $orderBy
      users: $users
      infringementTimestamp_Gte: $dateGte
      infringementTimestamp_Lt: $dateLt
    ) {
      edges {
        node {
          id
          fullName
          phoneNumber
          infringementsTotalValue
          infringementCount
        }
      }
    }
  }
`
